////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskCreationDefinition = {
	[ActionsTypes.RESET_DATA_CREATION_DEFINITION_CUSTOMER]: (state) => {
		return update(state, {
			initKioskCreation: {
				definition: {
					$set: { availableOptions: {}, data: {}, isEditable: true },
				},
				requestId: {
					$set: null,
				},
				statusId: {
					$set: 0,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: payload.data,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						selectedProfile: { $set: {} },
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_SUCCESS]: (state, payload) => {
		let availableOptions = cloneDeep(state.initKioskCreation.definition.availableOptions)
		availableOptions.selectedProfile = payload.data
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: availableOptions,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				requestId: {
					$set: payload.data.id,
				},
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				requestId: {
					$set: payload.data.id,
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					data: {
						$set: payload.data,
					},
					availableOptions: {
						kioskOwnerConfigs: {
							$set: payload.data.kioskOwnerConfigs,
						},
						kioskModels: {
							$set: payload.data.kioskModels,
						},
						availableLanguages: {
							$set: payload.data.availableLanguages,
						},
						installationTypes: {
							$set: payload.data.installationTypes,
						},
						countries: {
							$set: payload.data.countries,
						},
						storeTypes: {
							$set: payload.data.storeTypes,
						},
						kioskInformation: {
							$set: payload.data.kioskInformation,
						},
					},
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_CREATION_DEFINITION_BUSINESS]: (state) => {
		return update(state, {
			initKioskCreation: {
				definition: {
					$set: { availableOptions: {}, data: {}, isEditable: true, idCompanyCreated: null, rsCompanyCreated: null },
				},
				requestId: {
					$set: null,
				},
				statusId: {
					$set: 0,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: payload.data,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						listProfiles: { $set: [] },
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_SUCCESS]: (state, payload) => {
		let availableOptions = cloneDeep(state.initKioskCreation.definition.availableOptions)
		availableOptions.listProfiles = payload.data
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: availableOptions,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				requestId: {
					$set: payload.data.id,
				},
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				requestId: {
					$set: payload.data.id,
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					data: {
						$set: payload.data,
					},
					availableOptions: {
						owner: {
							$set: payload.data.owner,
						},
						manufacturer: {
							$set: payload.data.manufacturer,
						},
						reseller: {
							$set: payload.data.reseller,
						},
						kioskModels: {
							$set: payload.data.kioskModels,
						},
						availableLanguages: {
							$set: payload.data.availableLanguages,
						},
						installationTypes: {
							$set: payload.data.installationTypes,
						},
						countries: {
							$set: payload.data.countries,
						},
						warranty: {
							$set: payload.data.warranty,
						},
						tpaModel: {
							$set: payload.data.tpaModel,
						},
						integrator: {
							$set: payload.data.integrator,
						},
						connectivity: {
							$set: payload.data.connectivity,
						},
						salesmen: {
							$set: payload.data.salesmen,
						},
						kioskOwnerConfigs: {
							$set: payload.data.kioskOwnerConfigs,
						},
						displayStandsImplantation: {
							$set: payload.data.displayStandsImplantation,
						},
					},
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						selectedProfile: { $set: {} },
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_SUCCESS]: (state, payload) => {
		let availableOptions = cloneDeep(state.initKioskCreation.definition.availableOptions)
		availableOptions.selectedProfile = payload.data
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: availableOptions,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						owner: {
							$set: [],
						},
					},
				},
			},
		}),
	[ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						owner: {
							$set: payload.data.owner,
						},
					},
				},
			},
		})
	},
	[ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						kioskOwnerConfigs: { $set: {} },
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_SUCCESS]: (state, payload) => {
		let availableOptions = cloneDeep(state.initKioskCreation.definition.availableOptions)
		availableOptions.kioskOwnerConfigs = payload.data.kioskOwnerConfigs
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: availableOptions,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				definition: {
					availableOptions: {
						kioskOwnerConfigs: { $set: {} },
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_SUCCESS]: (state, payload) => {
		let availableOptions = cloneDeep(state.initKioskCreation.definition.availableOptions)
		availableOptions.kioskOwnerConfigs = payload.data.kioskOwnerConfigs
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				definition: {
					availableOptions: {
						$set: availableOptions,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default initKioskCreationDefinition
